export enum ERoutes {
  BASE = '/',
  WELCOME = '/welcome',
  LEADERBOARD = '/leaderboard',
  INGAME = '/ingame',
  DEV = '/dev',
}
